module.exports = __webpack_public_path__ + "img/gkrymscs.616c8c0f.png";